import React from 'react';
import BeneCard from './BeneCard';

const BeneSection = ({ model }) => {
    const beneficiaries = model.beneficiaries || [];

    // Normalize and map input type to a clear label
    const normalizeType = (type) => {
        if (!type) return 'unknown';
        const clean = type.trim().toLowerCase();
        if (clean.startsWith('p')) return 'primary';
        if (clean.startsWith('c')) return 'contingent';
        return 'unknown';
    };

    // Priority ranking for sorting: Primary (0), Contingent (1), Unknown (2)
    const typeRank = {
        primary: 0,
        contingent: 1,
        unknown: 2
    };

    const sortedBeneficiaries = [...beneficiaries].sort((a, b) => {
        const rankA = typeRank[normalizeType(a.type)] ?? 2;
        const rankB = typeRank[normalizeType(b.type)] ?? 2;

        if (rankA !== rankB) return rankA - rankB;

        const percentA = Number(a.percentage) || 0;
        const percentB = Number(b.percentage) || 0;

        return percentB - percentA; // Descending % within each type
    });

    if (sortedBeneficiaries.length === 0) {
        return (
            <div className="container container-section" id="beneficiaries-container">
                <div className="card notfoundbox rounded-3 shadow-lg">
                    <div className="card-body">
                        <div className="flex-container">
                            <h5>No Beneficiaries Found</h5>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="personCardContainer">
            {sortedBeneficiaries.map((bene, index) => (
                <BeneCard key={index} title={`Beneficiary ${index + 1}`} person={bene} />
            ))}
        </div>
    );
};

export default BeneSection;
